import { useReveal } from "@/hooks/useReveal";

export default function AboutSection() {
  const { ref, visible } = useReveal();

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <span className="num-label">SECTION 10 / ABOUT</span>
              <div className="flex-1 h-px bg-white/10" />
            </div>
            <h2
              data-testid="about-headline"
              className={`font-display font-bold text-axiom-text tracking-tight text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] reveal ${
                visible ? "in" : ""
              }`}
            >
              Built from <br />
              the Operator's <br />
              <span className="text-axiom-muted">Side of the Table.</span>
            </h2>

            <p
              className={`mt-6 text-axiom-muted text-base sm:text-lg leading-relaxed reveal ${
                visible ? "in" : ""
              }`}
              style={{ transitionDelay: "100ms" }}
            >
              Axiom-AI was built from decades of supply-chain operating experience,
              not theory alone. Its perspective comes from national-scale
              logistics, perishable distribution, transportation strategy,
              forecasting, network design, private fleet operations, and
              executive decision support.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div
              data-testid="founder-card"
              className={`axiom-card p-6 md:p-8 reveal ${visible ? "in" : ""}`}
              style={{ transitionDelay: "180ms" }}
            >
              <div className="flex items-start gap-5">
                {/* Initials block */}
                <div className="w-20 h-20 border border-white/15 flex items-center justify-center font-display text-2xl text-axiom-text shrink-0">
                  RB
                </div>
                <div className="flex-1">
                  <div className="num-label">FOUNDER</div>
                  <h3 className="mt-1 font-display text-2xl text-axiom-text font-bold">
                    Robert Bradic
                  </h3>
                  <p className="mt-3 text-sm text-axiom-muted leading-relaxed">
                    Brings more than two decades of supply-chain and logistics
                    experience, including national-scale work in grocery
                    distribution, forecasting, transportation optimization,
                    private fleet strategy, and continuous improvement.
                  </p>
                </div>
              </div>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 border border-white/10">
                {[
                  { k: "20+", v: "Years experience" },
                  { k: "40+", v: "DC scale" },
                  { k: "5", v: "Step framework" },
                  { k: "1:1", v: "Executive engagement" },
                ].map((s) => (
                  <div key={s.v} className="bg-axiom-bg p-4">
                    <div className="font-display text-2xl text-axiom-text">
                      {s.k}
                    </div>
                    <div className="num-label mt-1">{s.v}</div>
                  </div>
                ))}
              </div>

              <p
                className="mt-8 text-axiom-text/90 text-base leading-relaxed border-l-2 border-axiom-accent pl-4"
                data-testid="about-closing"
              >
                Axiom-AI is the intelligence layer built from that operating
                experience, designed to help leaders see what the network is
                already telling them.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
